import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";
import { CategoryListItem } from "component/listItem";
import { GameAction } from "component/modal";
import { isEmpty } from "lodash";
import ShowMoreFilters from "containers/ShowMoreFilters";
import { withNamespaces } from "react-i18next";
import "containers/Category/styles.scss";
import { CategoryFiltersComponent } from "component/filters";
import { setDefaultImageFormat } from "utils/image";

const CONTAINER_CONTENT = "CONTAINER_CONTENT";

const ACTION_MODAL = "ACTION_MODAL";

class Category extends Component {
  constructor(props) {
    super(props);
    this.calculateItemsPerRow = this._calculateItemsPerRow.bind(this);
    this.onGameItemClickHandler = this._onGameItemClickHandler.bind(this);
    this.onApplyFilterClickHandler = this._onApplyFilterClickHandler.bind(this);
    this.onReachEnd = this._onReachEnd.bind(this);
    this.loadGames = this._loadGames.bind(this);
    this.launchActions = this._launchActions.bind(this);
    this.resetPosition = this._resetPosition.bind(this);
    this.endRef = createRef();
    this.state = {
      enabledFilters: null,
      loading: false,
      selectedGame: null,
      realUrl: null,
      demoUrl: null,
      skeleton: props.isMobile ? [1, 2] : [1, 2, 3, 4],
      activeFilter: null,
    };
  }

  _calculateItemsPerRow() {
    try {
      // TODO: investigate why ref CATEGORY_LIST not found error
      let style = window.getComputedStyle(this.refs[CONTAINER_CONTENT]);
      let itemsPerRow = Number(style.getPropertyValue("--items-per-row"));
      if (itemsPerRow !== this.state.itemsPerRow) {
        this.setState({
          itemsPerRow: itemsPerRow,
        });
        //this.setItemsPerRow(this.props.items, itemsPerRow)
      }
    } catch (err) {
      console.log(err);
    }
  }

  _onReachEnd() {
    if (
      !this.props.isLoading &&
      !this.props.isLoadingNext &&
      !this.props.filtersIsLoading &&
      ((this.props.games &&
        this.props.games.get("page") < this.props.games.get("totalPages")) ||
        !this.props.games)
    ) {
      let page = this.props.games ? this.props.games.get("page") + 1 : 1;
      this.loadGames(this.props, page);
    }
  }

  initObserver() {
    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (this.endRef.current) {
                this.onReachEnd();
                /* this.initLoadDelay = setTimeout(() => {
                      this.getGames(this.props.link);
                      this.getTournamentPreview(this.props.links)
                  }, 500) */
              }
            } else {
              if (this.endRef.current) {
                //clearInterval(this.initLoadDelay)
              }
            }
          });
        },
        {
          rootMargin: "0px 0px 0px 0px",
          threshold: 0.5,
        },
      );
      observer.observe(this.endRef.current);
    } else {
      //this.getGames(this.props.link);
      //this.getTournamentPreview(this.props.links)
    }
  }

  _loadGames(props, page) {
    if (!props.gamesRoute) return;

    this.setState({
      loading: true,
    });

    let params = new URLSearchParams();
    params.append("size", 20);
    params.append("page", page);
    if (props.sortBy) {
      params.append("sortBy", props.sortBy);
    }

    if (props.filters) {
      props.filters.forEach((filter) => {
        filter.get("values").forEach((value) => {
          if (value.get("toggled") === true) {
            params.append(filter.get("id"), value.get("id"));
          }
        });
      });
    }

    this.props.fetchGames(props.gamesRoute, params).then(() => {
      this.setState({
        loading: false,
      });
    });
  }

  _resetPosition() {
    let { innerWidth } = window;
    let scrollY = document.getElementById("root").scrollTop;
    if (innerWidth >= 1400) {
      if (scrollY > 200) {
        document.getElementById("root").scrollTop = 200;
      }
    } else if (innerWidth >= 1200) {
      if (scrollY > 150) {
        document.getElementById("root").scrollTop = 150;
      }
    } else if (innerWidth >= 992) {
      if (scrollY > 100) {
        document.getElementById("root").scrollTop = 100;
      }
    } else if (innerWidth >= 768) {
      if (scrollY > 70) {
        document.getElementById("root").scrollTop = 70;
      }
    } else {
      if (scrollY > 75) {
        document.getElementById("root").scrollTop = 75;
      }
    }
  }

  componentDidMount() {
    this.initObserver();
    this.calculateItemsPerRow();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.filtersIsLoading !== this.props.filtersIsLoading &&
      prevProps.filtersIsLoading &&
      this.props.filters
    ) {
      this.loadGames(this.props, 1);
    }

    if (
      this.props.gamesRoute &&
      prevProps.gamesRoute !== this.props.gamesRoute &&
      !(this.props.filtersLink || prevProps.filtersLink)
    ) {
      this.loadGames(this.props, 1);
    }

    if (prevProps.sorting !== this.props.sorting && this.props.sorting) {
      this.loadGames(this.props, 1);
    }

    if (
      prevProps.sortBy !== this.props.sortBy &&
      this.props.sortBy &&
      !prevProps.filtersIsLoading
    ) {
      this.loadGames(this.props, 1);
    }
  }

  _onGameItemClickHandler(game, rel) {
    let gameId = game.get("gameId");
    //let nav = this.props.link ? this.props.link.get("rel") : null;
    this.props.gameClick(gameId, rel).then((response) => {
      if (response.location) {
        this.props.navigateTo(response.location);
      } else if (response.params) {
        this.props.setGameAction(response.params);
      }
    });
  }

  renderSortTitle(sortBy) {
    const { t } = this.props;

    let sortTitle;
    switch (sortBy) {
      case "editor":
        sortTitle = t("sortEditor");
        break;
      case "popularity":
        sortTitle = t("sortPopularity");
        break;
      case "newest":
        sortTitle = t("sortNewest");
        break;
      case "name":
        sortTitle = t("sortName");
        break;
      case "lastPlayed":
        sortTitle = t("sortLastPlayed");
        break;
      case "relevance":
        sortTitle = t("sortedRelevance");
        break;
      default:
        sortTitle = "Default";
        break;
    }

    if (sortTitle.includes("並べ替え") || sortTitle.includes("排序")) {
      return (
        <span className="sorted-by">
          &#8226;
          <span
            className="sort-btn"
            onClick={(event) => {
              event.stopPropagation();
              this.setState({
                activeFilter: "sortBy",
              });
            }}
          >
            {sortTitle}
          </span>
        </span>
      );
    } else {
      return (
        <span className="sorted-by">
          &#8226; {t("sortedBy")}
          <span
            className="sort-btn"
            onClick={(event) => {
              event.stopPropagation();
              this.setState({
                activeFilter: "sortBy",
              });
            }}
          >
            {sortTitle
              .split("by")
              .pop()
              .trim()}
          </span>
        </span>
      );
    }
  }

  _launchActions(game) {
    let { locale, sessionId, page, category } = this.props.match.params;
    let realLink;
    let demoLink;
    let params = {
      returnUrl: `${window.location.protocol}//${window.location.host}/${[
        locale,
        sessionId,
        "games",
        page,
        category,
      ].join("/")}`,
    };

    this.setState({
      realUrl: null,
      demoUrl: null,
    });

    try {
      realLink = game.get("links").find((link) => {
        return link.get("rel") === "launch.real";
      });
      this.props.fetchGameUrl(realLink, params).then((response) => {
        let realUrl = response.payload.data.url;
        this.setState({
          realUrl: realUrl,
        });
      });
    } catch (err) {}

    try {
      demoLink = game.get("links").find((link) => {
        return link.get("rel") === "launch.demo";
      });
      this.props.fetchGameUrl(demoLink, params).then((response) => {
        let demoUrl = response.payload.data.url;
        this.setState({
          demoUrl: demoUrl,
        });
      });
    } catch (err) {}
    this.props.showModal(ACTION_MODAL);
    this.setState({
      selectedGame: game,
    });
  }

  _onApplyFilterClickHandler() {
    this.props.showFilters(!this.props.filtersVisible);
  }

  render() {
    let ListItem = CategoryListItem;

    return (
      <div
        className={`contentContainer ${
          this.props.filtersVisible ? "filtersVisible" : ""
        }`}
        ref={CONTAINER_CONTENT}
      >
        {this.state.selectedGame && (
          <GameAction
            isMobile={this.props.isMobile}
            game={this.state.selectedGame}
            sizeSuffix={this.props.sizeSuffix}
            imgSrc={`${setDefaultImageFormat(
              this.state.selectedGame.getIn(["images", "bannerUrl"]) +
                "&width=180&theme=dark",
              this.props.imageFormat.get("banner"),
            )}`}
            realUrl={this.state.realUrl}
            demoUrl={this.state.demoUrl}
            onClose={() => {
              this.props.hideModal(ACTION_MODAL);
              this.setState({
                selectedGame: null,
              });
            }}
            onClick={(rel) => {
              this.props.hideModal(ACTION_MODAL);
              this.onGameItemClickHandler(this.state.selectedGame, rel);
              this.setState({
                selectedGame: null,
              });
            }}
          />
        )}
        <div
          className={`category-container ${
            this.props.isMobile ? "mobile" : ""
          } list`}
        >
          <CategoryFiltersComponent
            filters={this.props.filters}
            filterRoute={this.props.filtersLink}
            fetchFilters={(route) => {
              let params = new URLSearchParams();
              if (this.props.filters) {
                this.props.filters.forEach((filter) => {
                  //if(filter.get('id') !== "providers") {
                  filter.get("values").forEach((value) => {
                    if (value.get("toggled") === true) {
                      params.append(filter.get("id"), value.get("id"));
                    }
                  });
                  //}
                });
              }
              this.props.clearGames(this.props.link);
              this.props.fetchFilters(route, params);
            }}
            navigationMainFilters={this.props.navigationMainFilters}
            onApplyFilterClickHandler={(filter) => {
              this.onApplyFilterClickHandler();
              this.setState({
                activeFilter: filter.get("id"),
              });
            }}
            onSortClick={() => {
              this.onApplyFilterClickHandler();
              this.setState({
                activeFilter: "sortBy",
              });
            }}
            onFilterClickHandler={this.props.setActiveFilter}
            showSelectedFilter={false}
            games={this.props.games}
            link={this.props.link}
            sortBy={this.props.sortBy}
            sorts={this.props.sorts}
            enableClearAll={this.props.enableClearAll}
            clearAllFilters={this.props.clearAllFilters}
            isMobile={this.props.isMobile}
            sortingSize={this.props.sortingSize}
            filtersIsLoading={this.props.filtersIsLoading}
          />
          <div className="row">
            <div
              className={`col ${this.props.isMobile ? "nopadding" : ""}  ${
                this.props.filtersVisible ? "col-filter" : ""
              }`}
            >
              <div className="itemCollection row nopadding">
                {this.props.games &&
                  this.props.games.get("items").map((game, key) => {
                    let linkDemo = game.get("links").find((link) => {
                      return link.get("rel") === "launch.demo";
                    });
                    let linkReal = game.get("links").find((link) => {
                      return link.get("rel") === "launch.real";
                    });
                    let linkDetails = game.get("links").find((link) => {
                      return link.get("rel") === "game.details";
                    });
                    let gameLimit = game.get("gameLimit");

                    return (
                      <div className={`col col-item`} key={key}>
                        <ListItem
                          game={game}
                          linkDemo={linkDemo}
                          linkReal={linkReal}
                          linkDetails={linkDetails}
                          host={this.props.host}
                          key={key}
                          isMobile={this.props.isMobile}
                          onClick={(rel) => {
                            if (linkReal && this.props.isOneClickPlayEnabled)
                              return this.onGameItemClickHandler(
                                game,
                                linkReal.get("rel"),
                              );
                            if (linkDemo && this.props.isOneClickPlayEnabled)
                              return this.onGameItemClickHandler(
                                game,
                                linkDemo.get("rel"),
                              );
                            return this.onGameItemClickHandler(game, rel);
                          }}
                          onShowActionClick={() => {
                            this.launchActions(game);
                          }}
                          latestBroadcast={this.props.latestBroadcast}
                          currency={this.props.currency}
                          symbol={this.props.symbol}
                          imageFormat={this.props.imageFormat}
                          isOneClickPlayEnabled={
                            this.props.isOneClickPlayEnabled
                          }
                          gameLimit={gameLimit}
                        />
                      </div>
                    );
                  })}
                <div
                  className={`col col-end col-item 
                    ${this.props.isLoading ? "d-none" : ""} 
                    ${this.props.isLoadingNext ? "d-none" : ""} 
                    ${this.props.hasNextPage ? "" : "d-none"}`}
                  ref={this.endRef}
                >
                  <ListItem />
                </div>
                {(this.props.isLoading ||
                  this.props.isLoadingNext ||
                  this.props.hasNextPage) &&
                  this.state.skeleton.map((key) => {
                    return (
                      <div className={`col col-item`} key={key}>
                        <ListItem key={key} />
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
        <ShowMoreFilters
          refreshOnRouteChange={false}
          filtersIsLoading={this.props.filtersIsLoading}
          activeFilter={this.state.activeFilter}
          filters={this.props.filters}
          filtersLink={this.props.filtersLink}
          sorts={this.props.sorts}
          games={this.props.games}
          onClose={() => {
            this.setState({
              activeFilter: null,
            });
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let gamesRoute;
  let games;
  let filters;
  let filtersIsLoading;
  let filtersLink;
  let sortBy;
  let sorts;
  let enableClearAll;
  let sortingSize = 0;
  let isLoading = true;
  let isLoadingNext = false;
  let hasNextPage = true;
  let latestBroadcast;
  let currency = null;
  let navigationMainFilters;

  if (state.pages) {
    let contents = state.pages
      .get("wl-pages")
      .find((page) => {
        return page.get("rel") === "webLobbyMain";
      })
      .get("content");
    let content = contents.find(
      (content) => content.get("rel") === ownProps.match.params.page,
    );
    let links = content.get("links");
    filtersLink = links.find((link) => link.get("rel").indexOf("filters") > -1);
    gamesRoute = links.find((link) => link.get("rel").indexOf("games") > -1);

    if (state.games.get(gamesRoute.get("rel"))) {
      games = state.games.getIn([gamesRoute.get("rel"), "data"]);
    }
  }

  try {
    if (games.get("totalPages") > games.get("page")) {
      hasNextPage = true;

      if (ownProps.maxCount) {
        hasNextPage = ownProps.maxCount > games.get("items").size;
      }
    } else {
      hasNextPage = false;
    }
  } catch (err) {}

  try {
    latestBroadcast = state.serverSentEvent.getIn(["latestBroadcast"]);
  } catch (err) {}

  try {
    isLoading = state.games.getIn([gamesRoute.get("rel"), "isLoading"]);
  } catch (err) {}

  try {
    isLoadingNext = state.games.getIn([gamesRoute.get("rel"), "isLoadingNext"]);
  } catch (err) {}

  try {
    sortBy = state.filters.getIn([filtersLink.get("rel"), "data", "sortBy"]);
  } catch (err) {}

  try {
    sorts = state.filters.getIn([filtersLink.get("rel"), "data", "sorts"]);
  } catch (err) {}

  try {
    filters = state.filters.getIn([filtersLink.get("rel"), "data", "filters"]);
  } catch (err) {}

  try {
    navigationMainFilters = state.filters.getIn([
      filtersLink.get("rel"), 
      "data", 
      "navigation", 
      "mainFilters"
    ]);
  } catch (err) {}

  try {
    let toggledSize = 0;
    for (var i = 0; filters.size > i; i++) {
      toggledSize = filters.getIn([i, "toggledCount"]);
      sortingSize = sortingSize + toggledSize;
    }
  } catch (err) {}

  try {
    filtersIsLoading = state.filters.getIn([
      filtersLink.get("rel"),
      "isLoading",
    ]);
  } catch (err) {}

  try {
    enableClearAll = state.filters.getIn([
      filtersLink.get("rel"),
      "enableClearAll",
    ]);
  } catch (err) {}

  let symbols = null;
  if (!isEmpty(state.links.getIn(["symbol"]))) {
    let symbolList = state.links.getIn(["symbol"]);
    symbolList = symbolList.map((symbol) => {
      return String.fromCharCode(symbol);
    });
    symbols = symbolList.toJSON().join("");
  }

  if (!isEmpty(state.links.get("currency"))) {
    currency = state.links.get("currency");
  }

  return {
    isLoading,
    isLoadingNext,
    hasNextPage,
    filtersLink,
    gameDefaultAction: state.links.get("gameDefaultAction")
      ? state.links.get("gameDefaultAction")
      : null,
    isMobile: state.window.get("isMobile"),
    sorting: state.config.get("sorting"),
    host: state.config.get("host"),
    gamesRoute: gamesRoute,
    link: gamesRoute,
    filtersIsLoading: filtersIsLoading,
    filtersVisible: state.config.get("filtersVisible"),
    games: games,
    filters: filters,
    params: ownProps.match.params,
    modals: state.window.get("modals"),
    currency: currency,
    symbol: symbols,
    sortBy,
    sorts,
    sortingSize,
    enableClearAll,
    latestBroadcast,
    isMultiGame: state.links.get("isMultiGame"),
    imageFormat: state.window.get("imageFormat"),
    isOneClickPlayEnabled: state.links.get("isOneClickPlayEnabled"),
    navigationMainFilters: navigationMainFilters,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {
    fetchFilters: (route, params) => dispatchProps.fetchFilters(route, params),
    setActiveFilter: (category, subCategory, filter) =>
      dispatchProps.setActiveFilter(category, subCategory, filter),
    clearFilterByCategory: (category, subcategory) =>
      dispatchProps.clearFilterByCategory(category, subcategory),
    setGameAction: (params) => dispatchProps.setGameAction(params),
    navigateTo: (path) => ownProps.history.push(path),
    fetchGames: (route, params) => dispatchProps.fetchGames(route, params),
    clearGames: (route) => dispatchProps.clearGames(route),
    logout: () => dispatchProps.logout(),
    showFilters: (bol) => dispatchProps.showFilters(bol),
    showModal: (modal) => dispatchProps.showModal(modal),
    hideModal: (modal) => dispatchProps.hideModal(modal),
    fetchGameUrl: (link, params) => dispatchProps.fetchGameUrl(link, params),
    clearAllFilters: (category) => dispatchProps.clearAllFilters(category),
    gameClick: (gameId, playType, nav) =>
      dispatchProps.gameClick(gameId, playType, nav),
  });
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(withNamespaces("translation")(Category));
